import { render, staticRenderFns } from "./ResultsByPrice.vue?vue&type=template&id=6b9ceb44&scoped=true&"
import script from "./ResultsByPrice.vue?vue&type=script&lang=js&"
export * from "./ResultsByPrice.vue?vue&type=script&lang=js&"
import style0 from "./ResultsByPrice.vue?vue&type=style&index=0&id=6b9ceb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9ceb44",
  null
  
)

export default component.exports